export const ORDER = 'determine/ORDER';
export const ALIPAYS = 'determine/ALIPAYS';
export const WXPAY_LOADING = 'determine/WXPAY_LOADING';
export const WXPAY_LOADINGTRUE = 'determine/WXPAY_LOADINGTRUE';
export const WXPAYCODE = 'determine/WXPAYCODE';
export const ALIPAY_LOADINGTRUE = 'determine/ALIPAY_LOADINGTRUE';
export const ALIPAY_LOADINGFALSE = 'determine/ALIPAY_LOADINGFALSE';
export const CLOSEMODAL = 'determine/CLOSEMODAL';
export const OTHERPAY = 'determine/OTHERPAY'